export const CONFIRM_DELETE_ICON_HEADER = 'Are you sure you want to delete this item?';
